export const Routes = {
  Home: '/',
  Auth: '/auth',
  Signin: '/auth/signin',
  Signup: '/auth/signup',
  ForgotPassword: '/auth/forgot-password',
  Dashboard: '/admin',
  Account: '/admin/account',
  Appearance: '/admin/appearance',
  Pro: '/admin/pro',
};
